import { action } from 'satcheljs';

/**
 * Action to get shared folders for a particular user.
 * @param principalSMTPAddress The email id to identify for which root we are getting shared folders.
 * @param actionSource Source from where this action is called.
 */
export const getSharedFolders = action(
    'GET_SHARED_FOLDERS',
    (principalSMTPAddress: string, actionSource: string, isLoadingMore?: boolean) => ({
        principalSMTPAddress,
        actionSource,
        isLoadingMore,
    })
);
